import { createTraitGrowthFrames, fitTraitOrigins, TRAIT_GROWTH_DURATION } from "../../core/trait-growth-keyframes.js";

export const meta = Object.freeze({
  id: "grow-traits",
  label: "Wachsen mit Eigenschaften",
  duration: TRAIT_GROWTH_DURATION,
  description: "Klein starten, drei Eigenschafts-Wörter nacheinander aufnehmen und mit jedem Wort sichtbar wachsen.",
  tags: ["body", "growth", "words", "traits", "story", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  if (!scene?.growthTraits || scene.growthTraits.length !== 3) {
    throw new Error("Die Wachstums-Sequenz benötigt drei Eigenschafts-Wörter in der Stage.");
  }
  if (!scene.swarmRing || scene.swarmSparks.length !== 12) {
    throw new Error("Die Wachstums-Sequenz benötigt Ring und Funken des Mini-Orbi-Schwarms.");
  }

  const stageRect = scene.stage?.getBoundingClientRect();
  const origins = fitTraitOrigins({
    width: stageRect?.width,
    height: stageRect?.height,
    traitSizes: scene.growthTraits.map((trait) => ({ width: trait.offsetWidth, height: trait.offsetHeight })),
  });
  const frames = createTraitGrowthFrames({ origins });
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.actor, options),
    animate(elements.shadow, frames.shadow, options),
    animate(elements.svg, frames.blob, options),
    animate(elements.eyes, frames.eyesGlance, options),
    animate(elements.openEyes, frames.openEyes, options),
    animate(elements.smileEyes, frames.smileEyes, options),
    animate(elements.mouthParty, frames.mouthParty, options),
    animate(elements.mouthWhistleClosed, frames.mouthWow, options),
    animate(elements.glow, frames.glow, options),
    animate(scene.swarmRing, frames.ring, options),
    ...scene.swarmSparks.map((spark, index) => animate(spark, frames.sparks[index], options)),
    ...scene.growthTraits.map((trait, index) => animate(trait, frames.traits[index], options)),
  ];

  await Promise.allSettled(animations.map(({ finished }) => finished));
}
